var map = {
	"./arrow-down-blue.svg": 456,
	"./arrow-down-grey.svg": 457,
	"./arrow-right-white.png": 458,
	"./arrow-right.svg": 459,
	"./big_unicorn.png": 195,
	"./blue-loader.svg": 84,
	"./circle-grey.svg": 460,
	"./circle.svg": 461,
	"./coinbaseWalletIcon.svg": 128,
	"./dropdown-blue.svg": 462,
	"./dropdown.svg": 463,
	"./dropup-blue.svg": 464,
	"./ethereum-logo.png": 202,
	"./ethereum-logo1.png": 465,
	"./fortmaticIcon.png": 129,
	"./link.svg": 466,
	"./magnifying-glass.svg": 467,
	"./menu.svg": 468,
	"./metamask.png": 132,
	"./noise.png": 197,
	"./plus-blue.svg": 469,
	"./plus-grey.svg": 470,
	"./portisIcon.png": 130,
	"./question-mark.svg": 471,
	"./question.svg": 472,
	"./spinner.svg": 473,
	"./token-list-logo.png": 474,
	"./token-list/lists-dark.png": 475,
	"./token-list/lists-light.png": 476,
	"./token-logo.png": 83,
	"./tokenlistsgrouped.png": 477,
	"./trustWallet.png": 478,
	"./walletConnectIcon.svg": 131,
	"./x.svg": 479,
	"./xl_uni.png": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;